export default "__VITE_ASSET__CxrWRiUo__"